import { Button } from 'entities/Button'
import { RenderIf } from 'shared/helpers/renderIf'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import { ThemeSelectorContainer } from './styled'
import { Text } from 'entities/Text'
import { useThemeStore } from 'shared/store/themeSlice'

export const ThemeToggle = () => {
  const { toggleTheme, themeColor } = useThemeStore()

  return (
    <ThemeSelectorContainer>
      <Button handleClick={toggleTheme} width='42px' height='42px'>
        <RenderIf condition={themeColor === 'dark'}>
          <LightModeIcon />
        </RenderIf>
        <RenderIf condition={themeColor === 'light'}>
          <DarkModeIcon />
        </RenderIf>
      </Button>
      {/* TODO: translations */}
      <RenderIf condition={themeColor === 'dark'}>
        <Text>Use light theme</Text>
      </RenderIf>
      <RenderIf condition={themeColor === 'light'}>
        <Text>Use dark theme</Text>
      </RenderIf>
    </ThemeSelectorContainer>
  )
}
